module.exports = __webpack_public_path__ + "img/concreted.97ba3685.png";